import { useEffect, useState } from "react"
import WithSidebar from "../../../layouts/WithSidebar"
import './add.css'
import { useForm } from "../../../hooks/useForm"
import Input from "../../../blocks/Input"
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Link, useLocation } from "react-router-dom"
import { ajax } from "../../../scripts/helper"
import { useSnackbar } from 'notistack'
import utils from "../../../scripts/utils"
import { useNavigate } from "react-router-dom"
import CloseIcon from '@mui/icons-material/Close';


let types =  []

const AddPayment = () => {
    const { enqueueSnackbar } = useSnackbar()
    const navigate = useNavigate()
    const [isCustom, setCustom] = useState(false)
    const [generatingCustom, setGeneratingCustom] = useState(false)
    const [buttonText, setText] = useState('Send Custom Text')
    const [inputFields, handleChange, setInputFields] = useForm({
       customText: {
            name: "customText",
            value: "",
            type: "textarea",
            placeholder: "متن دلخواه ..."
        }
    })

    const {state } = useLocation()
    const [response, setResponse] = useState({})
    const handleChechbox = (e) => {
        console.log(e)
        if(e.target.checked === true){
            types.push(e.target.value)
        }
        if(e.target.checked === false){
            
            const index = types.indexOf(e.target.value)
            console.log(index, 'index')
            types.splice(index, 1)
        }
        console.log(types)
    }

    const getCurrencyAndProduct = async() => {
            const res = await ajax({
                method: 'GET',
                url: utils.urls.linkDetail(state.id),
                hasToken: true,
                snackbar: enqueueSnackbar
            })
    
            if (!res) return
    
            console.log(res, 'dataaaaaaaaaa')
    
            setResponse(res.data)

            console.log(response, 'response')
        
    }
    
    const getGenerateItinerary = async () => {
        setGeneratingCustom(true)
        const res = await ajax({
            method: 'GET',
            url: `${utils.urls.transactionItinerary}?transactionId=${state.id}`,
            hasToken: true,
            snackbar: enqueueSnackbar
        })
        setGeneratingCustom(false)
        if (!res) return
        setInputFields({
            ...inputFields,
            customText: {
                ...inputFields.customText,
                value: res.data.freeText
            }
        })
    }

    
    useEffect( () => {
        console.log(state, 'this is state')
        getCurrencyAndProduct()

        types = []
    }, [state])

    const notifyUser = async () => {
        console.log(types, 'typessss')
        if(types.length === 0){
            navigate('/agent/payments', {replace: true})
            return
        }
        let queryParams = `?transactionId=${state.id}`
        for (const type of types) {
            queryParams += `&notificationTypes=${type}`
        }

        if(isCustom == true){
            if (!inputFields.customText.value) {
                enqueueSnackbar('Custom text is empty', {variant:"error"})
                return
            }
            queryParams = `?transactionId=${state.id}&customText=${encodeURIComponent(inputFields.customText.value)}`
            for(const t of types) {
                console.log(' log ee dovom')
                if(t ==='SMS'){
                    queryParams += `&notificationTypes=SMS_CUSTOM`
                }
                if(t === 'EMAIL'){
                    queryParams += `&notificationTypes=EMAIL_CUSTOM`
                }
            }
        }

        // console.log(queryParams, utils.urls.notify + queryParams, 'yes yes')
        const res = await ajax({
            method: 'GET',
            url: utils.urls.notify + queryParams,
            hasToken: true,
            snackbar: enqueueSnackbar
        })

        if(!res) return

        enqueueSnackbar('Sent successfully', {variant: 'success'})
        navigate('/agent/payments', {replace: true})
    }
    
    return(
        <WithSidebar pageTitle={"Send Message"} breadcrumb={" Dashboard > Payment link > Create link > Send link"} >
            <div className="link-detail">
                <div className="link-value-label">
                    <label>Value</label>
                </div>
                <div className="link-amount">
                    <p className="p2">{state.amount.toLocaleString()}</p>
                    <p className="p1">{(response && response.currency ? response.currency.code : '')}</p>
                    
                </div>
                <div className="link-row">
                    <div className="link-first">
                        <label>Contact</label>
                        <span>{state.primaryContact}</span>
                    </div>
                    <div className="link-second">
                        <label>Phone number</label>
                        <span>{state.mobile}</span>
                    </div>
                </div>
                <div className="link-row">
                    <div className="link-first"> 
                        <label>Email</label>
                        <span>{state.email}</span>
                    </div>
                    <div className="link-second">
                        <label>Reference</label>
                        <span>{state.reference}</span>
                    </div>
                </div>
                <div className="link-row">
                    <div className="link-first">
                        <label>Product</label>
                        <span>{(response && response.product ? response.product.name : '')}</span>
                    </div>
                </div>
            </div>
            <div className="type-layout">
                <label>Type of messages</label>
                <div className="type-container">
                    <input value="SMS" type="checkbox" onChange={handleChechbox}></input>
                    <label className="label">SMS</label>
                </div>
                <div className="type-container">
                    <input value="EMAIL" type="checkbox" onChange={handleChechbox} ></input>
                    <lable className="label">Email</lable>
                </div>
                <button onClick={() =>{ setCustom(!isCustom)}}>{(isCustom ? 'Cancel' : 'Send Custom Text')}</button>
                <button disabled={generatingCustom} onClick={() =>{ getGenerateItinerary() }} style={{display: !isCustom? 'none': '', marginLeft:'5px'}}>Generate itinerary</button>
                <div className="textarea-container" style={{
                    display: !isCustom ? 'none' : ''
                }}>
                    <Input inputField={inputFields.customText} onChange={handleChange} />
                </div>
            </div>
            <div className="send-btn-container">
                <button className="back" onClick={() => navigate('/agent/payments', {replace: true})}>Back</button>
                <button className="send" onClick={notifyUser}>Send</button>
            </div>

        </WithSidebar>
    )
}
export default AddPayment